export const ACTION_CODE = 'EXPENSE' + '_ATTACHMENT' + '_ACTION';
